import { render, staticRenderFns } from "./Connection.vue?vue&type=template&id=03473dad&scoped=true"
import script from "./Connection.vue?vue&type=script&lang=js"
export * from "./Connection.vue?vue&type=script&lang=js"
import style0 from "./Connection.vue?vue&type=style&index=0&id=03473dad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03473dad",
  null
  
)

export default component.exports